module.exports = __webpack_public_path__ + "static/espa-1420-logo-e7bd202fddfbeaebea32fd5e0a02a46e.jpg";